import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const ModalGestionExternoSistemas = ({
    isOpen,
    registro,
    onSave,
    onClose,
    usuarioId,
    perfilId,
    estadosGestion = [],
    validacionCatalog = [],
    usuariosCatalog = []
}) => {
    const getLocalDate = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    };

    const getInitialState = () => ({
        usuario_id_solicitante: usuarioId,
        fecha_registro: getLocalDate(),
        cliente: '',
        requerimiento: '',
        validacion_id: '',
        comentario: '',
        fecha_inicio: '',
        comentario_cliente: '',
        fecha_entrega: '',
        estado: 1
    });

    const [formData, setFormData] = useState(getInitialState());

    useEffect(() => {
        if (isOpen) {
            if (registro) {
                setFormData({
                    gestion_tramite_id: registro.gestion_tramite_id,
                    usuario_id_solicitante: registro.usuario_id_solicitante,
                    fecha_registro: registro.fecha_registro?.split('T')[0] || '',
                    cliente: registro.cliente || '',
                    requerimiento: registro.requerimiento || '',
                    validacion_id: registro.validacion_id || '',
                    comentario: registro.comentario || '',
                    fecha_inicio: registro.fecha_inicio?.split('T')[0] || '',
                    comentario_cliente: registro.comentario_cliente || '',
                    fecha_entrega: registro.fecha_entrega?.split('T')[0] || '',
                    estado: registro.estado
                });
            } else {
                setFormData(getInitialState());
            }
        }
    }, [registro, isOpen, usuarioId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (!formData.requerimiento) {
            alert('Por favor, ingrese el requerimiento.');
            return;
        }

        const dataToSave = {
            ...formData,
            usuario_id_solicitante: parseInt(formData.usuario_id_solicitante),
            validacion_id: formData.validacion_id ? parseInt(formData.validacion_id) : null,
            estado: parseInt(formData.estado)
        };

        try {
            await onSave(dataToSave);
            onClose(true);
        } catch (error) {
            console.error("Error al guardar:", error);
        }
    };

    const isAdmin = Number(perfilId) === 8;
    const isNew = !registro;
    const canEdit = isNew || (Number(formData.estado) === 1);

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{registro ? 'EDITAR GESTIÓN EXTERNO' : 'NUEVA GESTIÓN EXTERNO'}</h1>
                    <Button className="close-btn" onClick={() => onClose()}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={(e) => e.preventDefault()}>

                        {!isAdmin && canEdit && (
                            <FormGroup>
                                <Label>Cliente: <span style={{ color: 'red' }}>*</span></Label>
                                <Input
                                    className="form-control"
                                    type="text"
                                    name="cliente"
                                    value={formData.cliente}
                                    onChange={handleChange}
                                    placeholder="Nombre del cliente."
                                    maxLength={255}
                                />
                            </FormGroup>
                        )}

                        <FormGroup>
                            <Label>Requerimiento: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="textarea"
                                name="requerimiento"
                                value={formData.requerimiento}
                                onChange={handleChange}
                                placeholder="Ingrese su requerimiento."
                                disabled={!isAdmin && !canEdit}
                                rows={8}
                                maxLength={255}
                            />
                            <small className="text-muted">{(formData.requerimiento?.length || 0)} / 255</small>
                        </FormGroup>

                        {isAdmin && (
                            <>
                                <FormGroup>
                                    <Label>Validación:</Label>
                                    <Input
                                        className="form-control"
                                        type="select"
                                        name="validacion_id"
                                        value={formData.validacion_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">Seleccione...</option>
                                        {validacionCatalog.map(v => (
                                            <option key={v.tipo_id} value={v.tipo_id}>{v.descripcion}</option>
                                        ))}
                                    </Input>
                                </FormGroup>

                                <FormGroup>
                                    <Label>Comentario:</Label>
                                    <Input
                                        className="form-control"
                                        type="textarea"
                                        name="comentario"
                                        value={formData.comentario}
                                        onChange={handleChange}
                                        placeholder="Ingrese su comentario."
                                        rows={5}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Fecha Inicio:</Label>
                                    <Input
                                        className="form-control"
                                        type="date"
                                        name="fecha_inicio"
                                        value={formData.fecha_inicio}
                                        onChange={handleChange}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Comentario Cliente:</Label>
                                    <Input
                                        className="form-control"
                                        type="textarea"
                                        name="comentario_cliente"
                                        value={formData.comentario_cliente}
                                        onChange={handleChange}
                                        placeholder="Ingrese comentario del cliente."
                                        rows={4}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Fecha Entrega:</Label>
                                    <Input
                                        className="form-control"
                                        type="date"
                                        name="fecha_entrega"
                                        value={formData.fecha_entrega}
                                        onChange={handleChange}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Estado:</Label>
                                    <Input
                                        className="form-control"
                                        type="select"
                                        name="estado"
                                        value={formData.estado}
                                        onChange={handleChange}
                                    >
                                        {estadosGestion.map(e => (
                                            <option key={e.tipo_id} value={e.tipo_id}>{e.descripcion}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </>
                        )}

                        {(isNew || isAdmin || canEdit) && (
                            <FormGroup>
                                <div className="button-container">
                                    <Button
                                        className="button-custom"
                                        onClick={async () => {
                                            if (window.confirm('¿Está seguro de guardar este registro?')) {
                                                await handleSubmit();
                                            }
                                        }}
                                    >
                                        {registro ? 'ACTUALIZAR' : 'REGISTRAR'}
                                    </Button>
                                </div>
                            </FormGroup>
                        )}

                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalGestionExternoSistemas;
